export default {
	data() {
		return {
			createCode: {
				isCreated: false,
				key: 0,
				table: {
					pagesize: 100,
					currentPage: 1,
					head: [],
					data: [],
				},
				tabled: {
					pagesize: 100,
					currentPage: 1,
					head: [],
					data: [],
				},
				packageTable: {
					pagesize: 100,
					currentPage: 1,
					head: [],
					data: [],
				},
				ztTable: {
					pagesize: 100,
					currentPage: 1,
					head: [],
					data: [],
				},
				tableList: {
					pagesize: 100,
					currentPage: 1,
					head: [],
					data: [],
				},
				tempData: [], //生成标签返回值
				rowClick: {},
				checkList: []
			},
			createLabelLoad: false,
			createLoad: false,
			activeName: 'first',
			printLoad: false,
			UNVAILVDALOAD: false,
			VDAPRCreated:false,
			cload:false,
			VDAPRILoad:false,
			moduleList:[],
			printMoudle:null,
			createdChangeP:false,
			calcuteLoad:false,
			CanZT:false
		}
	},
	watch: {
		activeName(old,n) {
			this.createCode.rowClick = {};
			this.createCode.checkList = [];
			this.createCode.key = Math.random(0, 1);
			
			this.$nextTick(()=>{
				let tableRef=null;
				if(n=='four') tableRef=this.$refs.ctablecreated_zt;
				if(n=='third') tableRef=this.$refs.ctablecreated_package;
				if(tableRef) tableRef.checkColumnChange();
			})
		}
	},
	computed:{
		IsCGY() {
			return this.userinfo.accountType == 'cgy'
		}
	},
	methods: {
		labelmodal_hide() {
			if (this.createLabelLoad||this.createLabelLoad||this.printLoad||this.UNVAILVDALOAD||this.createLabelLoad||this.createLoad) {
				this.$BH().message('请稍等');
				throw new Error('请稍等')
			} 
		},
		showCreateModal(show) {
			if (show) {
				if (this.checkList.length == 0){
					this.$BH().message('请选择数据');
					return;
				} 
				if (this.$refs.CreateModal)
					this.$refs.CreateModal.open();
				setTimeout(() => {
					this.createCode.key = Math.random(0, 1);
					this.ToCreate();
				}, 0);
			} else {
				if (this.createLabelLoad) {
					this.$BH().message('正在执行功能中，请稍后关闭');
					return;
				}
				//关闭
				this.activeName = 'first';
				this.createCode = {
					isCreated: false,
					key: 0,
					table: {
						pagesize: 100,
						currentPage: 1,
						head: [],
						data: [],
					},
					tabled: {
						pagesize: 100,
						currentPage: 1,
						head: [],
						data: [],
					},
					packageTable: {
						pagesize: 100,
						currentPage: 1,
						head: [],
						data: [],
					},
					ztTable: {
						pagesize: 100,
						currentPage: 1,
						head: [],
						data: [],
					},
					tableList: {
						pagesize: 100,
						currentPage: 1,
						head: [],
						data: [],
					},
					tempData: [], //生成标签返回值
					rowClick: {},
					checkList: []
				}
				this.moduleList=[];
				this.printMoudle=null
				if (this.$refs.CreateModal)
					this.$refs.CreateModal.close();
			}

		},
		ToCreate() {
			try {
				if (this.createLabelLoad) return;
				if (this.checkList.length == 0) throw '请先选择数据';
				this.createLabelLoad = true;
				this.$BH().base.http({
					url: 'Web/Trans_PRINTSOURCE',
					data: {
						FUser: this.userinfo.pfnumber,
						gysFUser: this.userinfo.fnumber,
						dtView: this.checkList,
						FType: this.userinfo.accountType,
						pageId:this.pageId,
						SOURCE:2
					},
					success: (res) => {
						let {
							data,
							head,
							moduleList,
							LastTNumber,
							CanZT
						} = res.data.value;
						this.createCode.table.data = data;
						this.createCode.table.head = head;
						this.CanZT=CanZT;
						this.moduleList=moduleList;
						if(this.moduleList.length>0) this.printMoudle=this.moduleList[0]['FTNumber']
						this.$nextTick(()=>{
							//赋值给下拉框
							if(LastTNumber){
								let len=this.moduleList.filter(item=>item.FTNumber==LastTNumber).length;
								if(len>0){
									this.printMoudle=LastTNumber;
								}
							}
						})
						setTimeout(()=>{
							this.$refs.ctablecreate?.checkColumnChange();
						},0);
					},
					loadingcontrol: () => {
						this.createLabelLoad = false;
					}
				});
			} catch (e) {
				this.$BH().message(e);
				this.createLabelLoad = false
			}
		},
		labelPrint(){
			try{
				//生成标签打印数据
				if(!this.VDAPRCreated) 
					this.createCode.checkList=JSON.parse(JSON.stringify(this.createCode.tabled.data));
				if(!this.createCode.checkList.length) throw '请先选择需要打印的信息行';
				if(this.createLabelLoad) return;
				this.createLabelLoad=true;
				this.$BH().base.http({
					url:'Web/GetLabelTemplate',
					data:{
						strUser:this.userinfo.pfnumber,
						moudleData:this.createCode.checkList,
						DocNumber:'02'
					},
					success:(res)=>{
						let templateBase=res.data.value.moudle;
						let date=Date.parse(new Date());
						if(!templateBase){
							this.$BH().message('模板数据值为空，请联系管理员');
							return;
						}
						this.$BH().base.http({
							baseUrl:window.__BH.PrintHtmlService.baseUrl,
							url:window.__BH.PrintHtmlService.dataUrl,
							data:{
								moduleData:JSON.stringify({
									BarCodeInfo:this.createCode.checkList
								}),
								name:'GYS',
								moudle:templateBase,
								date,
								machineCode:this.$store.getters.GUID
							},
							success:(res)=>{
								let {key,file}=res.data.value;
								window.open(`${window.__BH.PrintHtmlService.baseUrl}/Home?name=${key}&locale=zh-CHS`);
								if(file!='')
									this.$BH().DownLoadBase64({
										data:{
										base64Str:file,
										name:key+'.pdf'
										},
										loadingcontrol:()=>{
											this.createLabelLoad=false;
										}
									});
								else this.$BH().message('下载文件错误')
							},
							loadingcontrol:(res)=>{
								if(res!='success')
									this.createLabelLoad=false;
							}
						})
					},
					loadingcontrol:(res)=>{
						if(res!='success')
							this.createLabelLoad=false;
					}
				})
			}catch(e){
				//TODO handle the exception
				this.$BH().message(e);
				this.createLabelLoad=false;
			}
		},
		//两个数据源 混合打印
		labelPrinttwodata(){
			try{
				//生成标签打印数据
				if(!this.VDAPRCreated){
					if(this.activeName=='third') this.createCode.checkList=JSON.parse(JSON.stringify(this.createCode.packageTable.data));
					else if(this.activeName=='four') this.createCode.checkList=JSON.parse(JSON.stringify(this.createCode.ztTable.data));
					else this.createCode.checkList=JSON.parse(JSON.stringify(this.createCode.tabled.data));
				} 
				if(!this.createCode.checkList.length) throw '请先选择需要打印的信息行';
				let moudleName=this.printMoudle;
				if(this.VDAPRCreated){
					if(!this.createdChangeP){
						let diff = false;
						for (let i in this.createCode.checkList) {
							if (this.createCode.checkList[0]['打印模板'] != this.createCode.checkList[i]['打印模板']) {
								diff = true;
								break;
							}
						}
						if(diff) throw '选中记录模板不一致';
						moudleName=this.createCode.checkList[0]['打印模板'];
					}
				}
				if(this.createLabelLoad) return;
				this.createLabelLoad=true;
				this.$BH().base.http({
					url:'Web/GetLabelTemplates',
					data:{
						FUser: this.userinfo.pfnumber,
						gysFUser: this.userinfo.fnumber,
						moudleData:this.createCode.checkList,
						DocNumber:'02',
						SOURCE:2,
						pageId:this.pageId,
						moduleName:moudleName
					},
					success:(res)=>{
						let templateBase=res.data.value.moudle;
						let zttemplateBase=res.data.value.ztmoudle;
						let date=Date.parse(new Date());
						if(!templateBase){
							this.$BH().message('物料标签模板数据值为空，请联系管理员');
							return;
						}
						if(!zttemplateBase){
							this.$BH().message('组托标签模板数据值为空，请联系管理员');
							return;
						}
						//只需要按顺序打印 因为标签 是按照 组合的关系 查询出来的
						//模板名称按照 列设置
						let marr=[]
						for(let i in this.createCode.checkList){
							let code=JSON.parse(JSON.stringify(this.createCode.checkList[i]));
							if(code['名称']=="托条码"){
								code['___ptemp']='01'
							}else {
								code['___ptemp']='02'
							}
							marr.push(code)
						}
						//排序
						// marr=marr.sort(function(a,b){
						// 	return b['_id']-a['_id']
						// })
						this.$BH().base.http({
							baseUrl:window.__BH.PrintHtmlService.baseUrl,
							url:window.__BH.PrintHtmlService.dataUrlM,
							data:{
								moduleData:JSON.stringify({
									BarCodeInfo:marr
								}),
								name:'GYS',
								moudle:JSON.stringify({
									'01':zttemplateBase,
									'02':templateBase
								}),
								date,
								machineCode:this.$store.getters.GUID,
								TempCol:'___ptemp'
							},
							success:(res)=>{
								let {key,file}=res.data.value;
								window.open(`${window.__BH.PrintHtmlService.baseUrl}/Home?name=${key}&locale=zh-CHS`);
								if(file!='')
									this.$BH().DownLoadBase64({
										data:{
										base64Str:file,
										name:key+'.pdf'
										},
										loadingcontrol:()=>{
											this.createLabelLoad=false;
										}
									});
								else this.$BH().message('下载文件错误')
							},
							loadingcontrol:(res)=>{
								if(res!='success')
									this.createLabelLoad=false;
							}
						})
					},
					loadingcontrol:(res)=>{
						if(res!='success')
							this.createLabelLoad=false;
					}
				})
			}catch(e){
				//TODO handle the exception
				this.$BH().message(e);
				this.createLabelLoad=false;
			}
		},
		//生成标签
		CREATElabelfn(e){
			try{
				// console.log(this.createCode.table)
				if(this.createCode.table.data.length==0) throw '当前无可生成标签的数据';
				//在生成标签以后需要重新再次校验是否超量
				if(this.createCode.isCreated) throw '已经生成标签，不能重复生成';
				//检查是否填写了指定的值
				for(let i in this.createCode.table.data){
					if(this.createCode.table.data[i]['包装数量']=='0'||this.createCode.table.data[i]['包装数量']=='')
						throw '包装数量不允许为空';
					let printNum=this.createCode.table.data[i]['本次打印数量']
					let packNum=this.createCode.table.data[i]['包装数量']
					let Num = Math.ceil(printNum / packNum);
					Num = isNaN(Num) || Num == Infinity ? 0 : Num;
					this.createCode.table.data[i]['本次打印张数'] = Num;
				}
				if(this.createLoad) return;
				this.createLoad = true;
				this.$BH().base.http({
					url:'Web/CreateGetBRLabel_ZT',
					data:{
						user:this.userinfo.pfnumber,
						dtview: this.createCode.table.data,
						gysFUser:this.userinfo.fnumber,
						SOURCE:2,
						pageId:this.pageId,
						moduleName:this.printMoudle
					},
					success:(res)=>{
						this.activeName='second';
						for(let i in res.data.value.data||[]){
							res.data.value.data[i]['_id']=i;
						}
						this.createCode.tabled.head=res.data.value.columns;
						this.createCode.tabled.data=res.data.value.data;
						
						this.createCode.packageTable.data=res.data.value.Pageckage;
						this.createCode.packageTable.head=res.data.value.columns;
						
						this.createCode.ztTable.data=res.data.value.ZT;
						this.createCode.ztTable.head=res.data.value.columns;
						
						this.createCode.isCreated=true;
						setTimeout(()=>{
							this.$refs.ctablecreated?.checkColumnChange();
						},0);
					},
					loadingcontrol:()=>{
						this.createLoad=false;
					}
				});
			}catch(e){
				//TODO handle the exception
				this.$BH().message(e);
				this.createLoad=false;
			}
		},
		//已经生成的标签查看
		VDAPRCreatedFn(){
			try{
				if(this.checkList.length==0) throw '请先选择行'
				if(this.VDAPRCreated) return;
				this.VDAPRCreated=true;
				this.cload=true;
				this.$refs.CreatedModal?.open();
				setTimeout(()=>{
					this.GETCREATEDLABELS();
				},100);
				this.cload=false;
			}catch(e){
				//TODO handle the exception
				this.$BH().message(e);
				this.VDAPRCreated=false;
				this.cload=false;
			}
		},
		VDAPRCreatedFnClose(){
			this.$refs.CreatedModal?.close();
			this.createLabelLoad=false;
			this.createCode.tableList={
				pagesize: 100,
				currentPage: 1,
				head: [],
				data: [],
			}
			this.createCode.checkList=[];
			this.VDAPRCreated=false;
			this.cload=false;
			this.createdChangeP=false;
			this.printMoudle=null;
			this.moduleList=[]
		},
		//作废标签
		UNVAILVADA(){
			try{
				console.log('作废标签')
				if(!this.createCode.checkList.length) throw '请先选择需要作废的标签';
				if(this.UNVAILVDALOAD) return;
				this.UNVAILVDALOAD=true;
				// let arr=(this.createCode.checkList||[]).map(item=>item['_id']);
				this.$BH().base.http({
					url:'Web/LabeZF_ZT',
					data:{
						FUser:this.userinfo.pfnumber,
						FGYSNumber:this.userinfo.fnumber,
						FType:this.userinfo.accountType,
						rows:this.createCode.checkList,
						SOURCE:2,
						pageId:this.pageId
					},
					success:(res)=>{
						this.$BH().message('作废成功');
						this.GETCREATEDLABELS();
					},
					loadingcontrol:(res)=>{
						this.UNVAILVDALOAD=false;
					}
				})
			}catch(e){
				//TODO handle the exception
				this.$BH().message(e);
				this.UNVAILVDALOAD=false;
			}
		
		},
		listenToChild2(e){
			if(e&&e['rowClick']){
				this.createCode.rowClick=e['rowClick'];
			}else if(e&&e['checkList']) this.createCode.checkList=e['checkList'];
		},
		labeldeleteLine() {
			try {
				if (JSON.stringify(this.createCode.rowClick) == '{}') throw '请先选择行';
				//删除选中行
				let index = this.createCode.table.data.findIndex(item => {
					return item._id == this.createCode.rowClick._id
				});
				if (index > -1) {
					this.createCode.table.data.splice(index, 1)
					this.createCode.rowClick = {}
				}
			} catch (e) {
				//TODO handle the exception
				this.$BH().message(e);
			}
		},
		GETCREATEDLABELS(){
			try{
				if(this.checkList.length==0) throw '请先选择行'
				if(this.createLabelLoad) return;
				this.createLabelLoad=true;
				this.$BH().base.http({
					url:'Web/GetCreatedCode_ZT',
					data:{
						FUser:this.userinfo.pfnumber,
						gysFUser:this.userinfo.fnumber,
						FType:this.userinfo.accountType,
						dtView:this.checkList,
						SOURCE:2,
						pageId:this.pageId
					},
					success:(res)=>{
						this.createCode.tableList.head=res.data.value.head;
						this.createCode.tableList.data=res.data.value.data;
						this.moduleList=res.data.value.moduleList;
						if(this.moduleList.length>0) this.printMoudle=this.moduleList[0]['FTNumber']
						this.$refs.ctablecreatedList?.checkColumnChange();
						setTimeout(()=>{
							console.log(this.createCode.tableList.head)
							this.$refs.ctablecreatedList?.forUpdate();
						},400);
					},
					loadingcontrol:()=>{
						this.createLabelLoad=false;
					}
				})
			}catch(e){
				//TODO handle the exception
				this.$BH().message(e);
				this.createLabelLoad=false;
			}
		},
		createFit(e) {
			// console.log('列属性')
			if (this.activeName == 'first') {
				this.createCode.table.head = e;
			} else if(this.activeName=='second'){
				this.createCode.tabled.head = e;
			}else if(this.activeName=='four'){
				this.createCode.ztTable.head = e;
			}else if(this.activeName=='third'){
				this.createCode.packageTable.head = e;
			}else if(this.VDAPRCreated){
				this.createCode.tableList.head=e;
			}
			this.createCode.key=Math.random();
		},
		//触发刷新
		TABCHANGE(e){
			if(e){
				let {paneName}=e;
				// if(paneName=='third'){
				// 	this.GETCREATEDLABELS();
				// }else 
				this.createCode.checkList=[]
				if(paneName=='first'&&!this.createCode.isCreated){
					this.ToCreate();
				}
			}
		},
	}
}